import script from "./TagInput.vue?vue&type=script&setup=true&lang=js"
export * from "./TagInput.vue?vue&type=script&setup=true&lang=js"

import "./TagInput.vue?vue&type=style&index=0&id=62d2ecd0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62d2ecd0"]])

export default __exports__